import GraphicStorageLinkField from "./graphic-storage-link-field";
import GraphicStorageViewField from "./graphic-storage-view-field";


const GraphicStorageFields = {
    View: GraphicStorageViewField,
    Link: GraphicStorageLinkField,
}

export default GraphicStorageFields;
